// タブ切り替え（FAQ含む汎用対応）
const tab = () => {
    // 対象コンテナ（既存FAQ用 .un_faq と汎用 .js_tab の両対応）
    const containers = document.querySelectorAll('.un_faq, .js_tab');
    if (!containers.length) return;

    containers.forEach(container => {
        // ナビリンク（既存 .un_faq_nav_link と汎用 .js_tab_link）
        const navLinks = container.querySelectorAll('.un_faq_nav_link, .js_tab_link');
        // セクション（既存 .un_faq_section と汎用 .js_tab_section）
        const sections = container.querySelectorAll('.un_faq_section, .js_tab_section');
        if (!navLinks.length || !sections.length) return;

        const clearActive = () => {
            navLinks.forEach(link => link.classList.remove('is-active'));
            sections.forEach(section => section.classList.remove('is-active'));
        }

        const activateBySelector = (selector, updateHash = false) => {
            // コンテナ内を優先して対象を取得。見つからなければ全体からもフォールバック
            let target = null;
            if (selector.startsWith('#')) {
                target = container.querySelector(selector) || document.querySelector(selector);
            } else {
                target = container.querySelector(selector);
            }
            if (!target) return;

            clearActive();
            target.classList.add('is-active');

            // 対応するナビリンクにもアクティブ付与
            navLinks.forEach(link => {
                const linkTarget = link.dataset.target || link.getAttribute('href');
                if (linkTarget === selector) {
                    link.classList.add('is-active');
                }
            });

            // ハッシュ更新（スクロールさせずにURLのみ変更）
            if (updateHash && history.replaceState) {
                const idOrSelector = target.id ? `#${target.id}` : selector;
                history.replaceState(null, '', idOrSelector);
            }
        }

        // クリックイベント
        navLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const selector = link.dataset.target || link.getAttribute('href');
                if (!selector) return;
                activateBySelector(selector, true);
            });
        });

        // 初期表示：ハッシュ優先、なければ既存のis-activeを踏襲
        const { hash } = window.location;
        if (hash && container.querySelector(hash)) {
            activateBySelector(hash, false);
        } else {
            // 既にis-activeが付いているセクションに対応するナビを同期
            const current = container.querySelector('.un_faq_section.is-active, .js_tab_section.is-active');
            if (current) {
                const currentId = current.id ? `#${current.id}` : null;
                if (currentId) {
                    navLinks.forEach(link => {
                        const selector = link.dataset.target || link.getAttribute('href');
                        if (selector === currentId) {
                            link.classList.add('is-active');
                        }
                    });
                } else if (navLinks[0]) {
                    navLinks[0].classList.add('is-active');
                }
            }
        }
    });
}

export default tab;


